import { addMessages } from '@hana/i18n';

// Chuỗi giao diện Tư vấn HS. Mã HS, mã hiệp định, tên riêng và dữ liệu mẫu không dịch.
addMessages('vi', {
  'hs.cfWait': 'Chờ xác nhận',
  'hs.cfOk': 'Đã xác nhận',
  'hs.cfBack': 'Trả lại',
  'hs.backSvc': 'Quay lại Dịch vụ',
  'hs.title': 'Tư vấn HS',
  'hs.sub': 'Biểu thuế XNK 2026 · cập nhật 01/Oct/2026',
  'hs.attach': 'Gắn vào job',
  'hs.pickJob': 'Chọn job',
  'hs.openJobs': 'Job đang mở của VINAVARIETY',
  'hs.noWrite': 'Chưa mở ghi ở bản này',
  'hs.sendCust': 'Gửi khách',
  'hs.pdf': 'Xuất PDF',
  'hs.pdfDone': 'Đã xuất PDF “Tu-van-HS-{code}.pdf”',
  'hs.saveCat': 'Lưu danh mục hàng khách',
  'hs.noSavePerm': 'Bạn không có quyền lưu danh mục',
  'hs.needConfirm': 'Cần nhân viên hải quan xác nhận mã trước',
  'hs.recent': 'Tra cứu gần đây',
  'hs.roNote': 'Chỉ xem · không xác nhận mã và không lưu vào danh mục hàng khách.',
  'hs.goodsInfo': 'Thông tin hàng',
  'hs.goodsH': 'Hàng cần tra mã',
  'hs.dir': 'Chiều',
  'hs.imp': 'Nhập khẩu',
  'hs.exp': 'Xuất khẩu',
  'hs.customer': 'Khách hàng',
  'hs.descL': 'Mô tả hàng',
  'hs.photos': 'Ảnh / catalogue',
  'hs.photo1': 'Ảnh 1',
  'hs.catalogue': 'Catalogue',
  'hs.add': 'Thêm',
  'hs.photoAdded': 'Đã thêm ảnh · Ask HANA sẽ đọc kèm khi đề xuất lại',
  'hs.custCode': 'Mã khách gợi ý',
  'hs.diffAi': 'Khác mã AI đề xuất',
  'hs.originImp': 'Xuất xứ hàng (để chọn FTA)',
  'hs.originExp': 'Thị trường nhập khẩu',
  'hs.askAi': 'Ask HANA đề xuất mã',
  'hs.reAsked': 'Ask HANA đã đề xuất lại 3 mã · việc HSC giao NHIDTT',
  'hs.confirmSec': 'Xác nhận mã',
  'hs.confirmH': 'Xác nhận mã · việc HSC',
  'hs.due': 'hạn 23/Oct/2026 11:00',
  'hs.confirmer': 'Người xác nhận',
  'hs.log1': 'Ask HANA đề xuất 8516.71.00 (92%) · DAVID tra cứu',
  'hs.log2ok': 'NHIDTT xác nhận 8516.71.00',
  'hs.log2back': 'NHIDTT trả lại: cần catalogue công suất',
  'hs.log2wait': 'Chờ NHIDTT xác nhận',
  'hs.log2waitSub': 'giao lúc 10:12 · theo quy tắc OPS chứng từ',
  'hs.returnedTo': 'Đã trả lại đề xuất cho DAVID',
  'hs.confirmBtn': 'Xác nhận {code}',
  'hs.confirmedToast': 'Đã xác nhận {code} · đóng việc HSC',
  'hs.emptyT': 'Chưa có đề xuất mã',
  'hs.emptyD': 'Nhập mô tả hoặc thêm ảnh hàng bên trái, rồi bấm “Ask HANA đề xuất mã”. Kết quả gồm mã HS 8 số, lý do, biểu thuế và so sánh FTA.',
  'hs.errT': 'Không đọc được biểu thuế',
  'hs.errD': 'Nguồn biểu thuế 2026 không phản hồi lúc 22/Oct/2026 10:42. Mô tả hàng vẫn được giữ.',
  'hs.retry': 'Thử lại',
  'hs.candSec': 'Mã đề xuất',
  'hs.candH': 'Ask HANA đề xuất · 3 mã HS 8 số',
  'hs.tariffSec': 'Biểu thuế',
  'hs.taxH': 'Thuế 2026 · {code}',
  'hs.taxImp': 'Xuất xứ {o} · thuế nhập khẩu vào Việt Nam',
  'hs.taxExp': 'Xuất sang {o} · thuế xuất khẩu VN + C/O cho nước nhập',
  'hs.policy': 'Chính sách & quản lý chuyên ngành',
  'hs.ftaSec': 'So sánh FTA',
  'hs.ftaH': 'So sánh FTA · chọn C/O tốt nhất',
  'hs.ftaImp': 'Xuất xứ {o} · 2026',
  'hs.ftaExp': 'Thuế tại {o} · C/O Việt Nam',
  'hs.thAgr': 'Hiệp định',
  'hs.thForm': 'Form C/O',
  'hs.thTax': 'Thuế 2026',
  'hs.thRule': 'Quy tắc xuất xứ',
  'hs.thApply': 'Áp dụng',
  'hs.lookup': 'Tra cứu',
  'hs.pend': 'Chờ xác nhận · 3',
});
addMessages('en', {
  'hs.cfWait': 'Awaiting confirmation',
  'hs.cfOk': 'Confirmed',
  'hs.cfBack': 'Returned',
  'hs.backSvc': 'Back to Services',
  'hs.title': 'HS advisor',
  'hs.sub': '2026 import/export tariff · updated 01/Oct/2026',
  'hs.attach': 'Attach to job',
  'hs.pickJob': 'Choose job',
  'hs.openJobs': 'Open jobs of VINAVARIETY',
  'hs.noWrite': 'Writing is not enabled in this version',
  'hs.sendCust': 'Send to customer',
  'hs.pdf': 'Export PDF',
  'hs.pdfDone': 'Exported PDF “Tu-van-HS-{code}.pdf”',
  'hs.saveCat': 'Save to customer goods list',
  'hs.noSavePerm': 'You have no permission to save the list',
  'hs.needConfirm': 'A customs officer must confirm the code first',
  'hs.recent': 'Recent lookups',
  'hs.roNote': 'View only · cannot confirm codes or save to the customer goods list.',
  'hs.goodsInfo': 'Goods details',
  'hs.goodsH': 'Goods to classify',
  'hs.dir': 'Direction',
  'hs.imp': 'Import',
  'hs.exp': 'Export',
  'hs.customer': 'Customer',
  'hs.descL': 'Goods description',
  'hs.photos': 'Photos / catalogue',
  'hs.photo1': 'Photo 1',
  'hs.catalogue': 'Catalogue',
  'hs.add': 'Add',
  'hs.photoAdded': 'Photo added · Ask HANA will read it on the next suggestion',
  'hs.custCode': 'Customer-suggested code',
  'hs.diffAi': 'Differs from AI suggestion',
  'hs.originImp': 'Origin of goods (to pick FTA)',
  'hs.originExp': 'Importing market',
  'hs.askAi': 'Ask HANA to suggest a code',
  'hs.reAsked': 'Ask HANA suggested 3 codes again · HSC task assigned to NHIDTT',
  'hs.confirmSec': 'Code confirmation',
  'hs.confirmH': 'Code confirmation · HSC task',
  'hs.due': 'due 23/Oct/2026 11:00',
  'hs.confirmer': 'Confirmer',
  'hs.log1': 'Ask HANA suggested 8516.71.00 (92%) · looked up by DAVID',
  'hs.log2ok': 'NHIDTT confirmed 8516.71.00',
  'hs.log2back': 'NHIDTT returned it: power catalogue needed',
  'hs.log2wait': 'Awaiting NHIDTT confirmation',
  'hs.log2waitSub': 'assigned 10:12 · by OPS documents rule',
  'hs.returnedTo': 'Suggestion returned to DAVID',
  'hs.confirmBtn': 'Confirm {code}',
  'hs.confirmedToast': 'Confirmed {code} · HSC task closed',
  'hs.emptyT': 'No code suggestion yet',
  'hs.emptyD': 'Enter a description or add photos on the left, then press “Ask HANA to suggest a code”. Results include the 8-digit HS code, reasons, tariff and FTA comparison.',
  'hs.errT': 'Cannot read the tariff',
  'hs.errD': 'The 2026 tariff source did not respond at 22/Oct/2026 10:42. Your goods description is kept.',
  'hs.retry': 'Retry',
  'hs.candSec': 'Suggested codes',
  'hs.candH': 'Ask HANA suggests · 3 eight-digit HS codes',
  'hs.tariffSec': 'Tariff',
  'hs.taxH': '2026 tax · {code}',
  'hs.taxImp': 'Origin {o} · import duty into Vietnam',
  'hs.taxExp': 'Export to {o} · Vietnam export duty + C/O for importing country',
  'hs.policy': 'Policies & specialised controls',
  'hs.ftaSec': 'FTA comparison',
  'hs.ftaH': 'FTA comparison · pick the best C/O',
  'hs.ftaImp': 'Origin {o} · 2026',
  'hs.ftaExp': 'Duty in {o} · Vietnam C/O',
  'hs.thAgr': 'Agreement',
  'hs.thForm': 'C/O form',
  'hs.thTax': '2026 duty',
  'hs.thRule': 'Rules of origin',
  'hs.thApply': 'Applicable',
  'hs.lookup': 'Lookups',
  'hs.pend': 'Awaiting confirmation · 3',
});
